import { toast, ToastOptions } from "react-toastify";
import Checkmark from "./Icons/Checkmark";
import Close from "./Icons/Close";
import Text from "./Tailwind/Text";

type ToastVariant = "success" | "error";

const toastConfig: ToastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const styles = {
  success: {
    style: {
      background: "#eaf5eb",
    },
  },
  error: {
    style: {
      background: "#fdedee",
    },
  },
};

export const showToast = (
  message: string,
  variant: ToastVariant = "success"
) => {
  toast(
    <div
      style={{ display: "flex", alignItems: "center", gap: "8px", padding: 0 }}
    >
      {variant === "success" && (
        <Checkmark className="checkmark" fill="var(--green)" />
      )}
      {variant === "error" && (
        <Close className="checkmark" fill="var(--red)" width={9} />
      )}
      <Text
        variant="body3"
        className={variant === "success" ? "text-[#77b448]" : "text-[#f46a6a]"}
      >
        {message}
      </Text>
    </div>,
    {
      ...toastConfig,
      ...styles[variant],
    }
  );
};
